import { useEffect, useState } from 'react';
import { useAuth, canUseApp, isSimpleMenu } from '@/auth/AuthContext';
import { HubTabs } from '@/components/HubTabs';
import ITFloormap from '@/pages/it/ITFloormap';
import BihinFloormap from '@/pages/bihin/BihinFloormap';
import { bihinApi } from '@/pages/bihin/bihinApi';

/** フロアマップ（IT資産 / 備品）— ひとつの画面。 */
export default function FloormapHub({ side = 'it' }) {
  const { user } = useAuth();
  const simple = isSimpleMenu(user);
  const [access, setAccess] = useState(null);

  useEffect(() => {
    if (side === 'bihin') return;
    bihinApi.access?.().then(setAccess).catch(() => {});
  }, [side]);

  const tabs = [
    {
      key: 'it', label: 'IT資産', node: <ITFloormap />,
      visible: side === 'it' || (simple && canUseApp(user, 'it')),
    },
    {
      key: 'bihin', label: '備品', node: <BihinFloormap access={access || undefined} />,
      visible: side === 'bihin' || (simple && canUseApp(user, 'bihin')),
    },
  ];

  return <HubTabs tabs={tabs} initial={side} testid="floormap-hub" />;
}
